export default __webpack_public_path__ + "06b6a0459e563f0b7d98ed6cde05785b.jpg";